import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CONTACT_US_PHONE_MAIN, CONTACT_US_WEB_MAIN, PRIVACY_EMAIL } from '../../shared/constants';

@Component({
    selector: 'app-privacy-policy',
    imports: [],
    templateUrl: './privacy-policy.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './privacy-policy.component.scss'
})
export class PrivacyPolicyComponent {
  CONTACT_US_PHONE_MAIN: string = CONTACT_US_PHONE_MAIN
  CONTACT_US_WEB_MAIN: string = CONTACT_US_WEB_MAIN
  PRIVACY_EMAIL: string = PRIVACY_EMAIL
}
